export enum AddProgramFormFieldName {
  Medicine = "medicine",
  ProgramTemplate = "program",
  StartDate = "startDate",
}
